export default __webpack_public_path__ + "static/media/upIcon.805f2384.svg";